import { z } from "zod";
import { ProseSchema } from "./prose.js";
const Guidance = ProseSchema.refine((value) => value.length <= 300, "Keep voice guidance bounded");
/** Authored presentation only. Never derive this by exposing private NPC notes. */
export const NarratorVoiceSchema = z.strictObject({
    version: z.literal(1), rhythm: Guidance, answering: Guidance, evasion: Guidance, pressure: Guidance, restraint: Guidance,
    examples: z.strictObject({ quiet: Guidance, pressured: Guidance }),
});
export const NarrativeTextureSchema = z.strictObject({ id: z.string().min(1).max(80), text: ProseSchema.refine((text) => text.length <= 180, "Keep texture brief") });
export const ExpressionUseSchema = z.strictObject({ version: z.literal(1), textureIds: z.array(z.string().max(80)).max(1), variantIds: z.array(z.string().max(80)).max(6) });
/** Soft reminders derived only from final prose. These are never evidence or canon. */
export const ExpressionMemorySchema = z.strictObject({
    version: z.literal(1), window: z.literal(6),
    openings: z.array(z.string().max(120)).max(3), closings: z.array(z.string().max(120)).max(3),
    phrases: z.array(z.string().max(60)).max(6), textureIds: z.array(z.string().max(80)).max(6), variantIds: z.array(z.string().max(80)).max(6),
});
//# sourceMappingURL=narrator-expression.js.map